import { render, staticRenderFns } from "./SACTableSearch.vue?vue&type=template&id=3fbc00a4"
import script from "./SACTableSearch.vue?vue&type=script&lang=js"
export * from "./SACTableSearch.vue?vue&type=script&lang=js"
import style0 from "./SACTableSearch.vue?vue&type=style&index=0&id=3fbc00a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports